<template>
    <modal v-if="isVisible">
      <template v-slot:header>
        <h5 class="modal-title">{{$t('dialogs.export-protocol.title')}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
          <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
        </button>
      </template>

      <template v-slot:body>
        <div>
          <div class="modal-body__registration">
            <p class="u-text-left">
              {{$t('dialogs.export-protocol.match-fields-from-template-with-fields-from-table')}}
            </p>
          </div>
          <div class="modal-body__content-download">
            <div class="modal-body__group">
              <div class="a-label">{{$t('dialogs.export-protocol.who-voted')}}:</div>
              <dropdown-new class="a-input-group select-w-180" v-model="voting">
                <option value="in-person">{{$t('dialogs.export-protocol.voting.in-person')}}</option>
                <option value="absentee">{{$t('dialogs.export-protocol.voting.absentee')}}</option>
              </dropdown-new>
            </div>
            <div class="modal-body__group">
              <p class="u-text-left">
                {{$t('dialogs.export-protocol.decision-of-every-member')}}:
              </p>
            </div>
            <div class="modal-body__group">
              <div class="table-tab">
                <div class="table-tab__container" style="overflow:initial!important;">
                  <table class="table-tab__block table " style="width: 100%">
                    <thead class="table-tab__thead">
                    <tr class="">
                      <th>{{$t('labels.username')}}</th>
                      <th>{{$t('dialogs.export-protocol.table.attended')}}</th>
<!--                      <th>{{$t('dialogs.export-protocol.table.result')}}</th>-->
                    </tr>
                    </thead>
                    <tbody class="table-tab__tbody">
                      <tr class="table-tab__tr-border" v-for="member in members">
                        <td>{{member | fullName}}</td>
                        <td>
                          <dropdown-new class="a-input-group select-w-180" v-model="member.presence">
                            <option value="yes">{{$t('dialogs.export-protocol.table.attended-yes')}}</option>
                            <option value="no">{{$t('dialogs.export-protocol.table.attended-no')}}</option>
                          </dropdown-new>
                        </td>
<!--                        <td>-->
<!--                          <dropdown-new class="a-input-group select-w-180" v-model="member.vote">-->
<!--                            <option value="yes">{{$t('dialogs.export-protocol.table.vote-for')}}</option>-->
<!--                            <option value="no">{{$t('dialogs.export-protocol.table.vote-against')}}</option>-->
<!--                            <option value="abstained">{{$t('dialogs.export-protocol.table.abstain')}}</option>-->
<!--                          </dropdown-new>-->
<!--                        </td>-->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-body__group">
              <div class="a-label">{{$t('dialogs.export-protocol.final-decision')}}:</div>
              <dropdown-new class="a-input-group select-w-180" v-model="decision">
                <option value="good" :label="'dialogs.export-protocol.final-decision-good'"></option>
                <option value="bad" :label="'dialogs.export-protocol.final-decision-bad'"></option>
                <option value="other" :label="'dialogs.export-protocol.final-decision-other'"></option>
              </dropdown-new>
            </div>
            <div class="modal-body__group" v-if="decision === 'other'">
              <textarea class="a-textarea" rows="2" v-model="reason"></textarea>
            </div>
          </div>

          <span class="a-formatted-text a-color-red" v-if="alertMessage">{{alertMessage}}</span>
        </div>
      </template>

      <template v-slot:footer>
        <button class="gui-btn gui-btn--white-border gui-btn--ep" type="button" @click="close" v-t="'buttons.cancel'"></button>
        <button class="gui-btn gui-btn--red gui-btn--ep" type="button" v-t="'buttons.save'" @click="notify"></button>
      </template>
    </modal>
</template>

<script>
  import Modal from '@/widgets/modal'
  import Dropdown from '@/widgets/dropdown'

  export default {
    props: {
      commission: Array
    },

    components: {
      Modal, Dropdown
    },

    data: () => ({
      isVisible: false,
      alertMessage: undefined,
      voting: 'in-person',
      decision: 'good',
      reason: undefined,

      members: []
    }),

    created() {
      this.members = this.commission.map(e => ({
        ...e,
        presence: 'yes',
        //vote: 'yes'
      }))
    },

    methods: {
      close() {
        this.isVisible = false
      },

      open(alertMessage) {
        this.alertMessage = alertMessage;
        this.isVisible = true
      },

      notify() {
        this.$emit('save', {
          voting: this.voting,
          decision: this.decision,
          reason: this.reason,
          members: this.members.map(e => ({
            id: e.id,
            presence: e.presence,
            //vote: e.vote
          }))
        })
      }
    }
  }
</script>

<style scoped>

</style>
